import { required, helpers, maxLength } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

const codePattern = helpers.regex(/^[a-z0-9_]+$/);

export default function (formState) {
  return {
    form: {
      code: {
        required: helpers.withMessage(i18n.global.t('_delivery.Please enter a channel code'), required),
        codePattern: helpers.withMessage(i18n.global.t('_delivery.Lowercase letters, numbers and underscore only'), codePattern),
        maxLength: maxLength(30)
      },
      name: {
        required: helpers.withMessage(i18n.global.t('_delivery.Please enter a channel name'), required),
        maxLength: maxLength(100)
      }
    }
  }
};
